import { useQuery } from "@tanstack/react-query";
import trainsService from "services/admin/trainsService";

export const useGetTrains = (queryParams = {}) => {
  return useQuery({
    queryKey: ["trains", queryParams],
    queryFn: async () => {
      const response = await trainsService.getAll(queryParams);
      return response.data;
    },
  });
};
